<script setup>
import { useAuthStore } from '~/stores/auth.store';
const auth = useAuthStore();

auth.logout({ redirect: false, path: '/', reload: true });
</script>
<template><div></div></template>
